import packageJson from '../../../../package.json';

const appVersion = packageJson.version;

export const generateKeyForLocalStorageFilters = (userName: string) =>
  `NORTADA_FILTERS_${appVersion}_${userName.toUpperCase()}`;
